import TeamBadge from "@/components/base/TeamBadge";
import type { PlayerStat } from "@/utils/roster";

type LineupCardProps = {
  teamName: string;
  shortName: string;
  color: string;
  roster: PlayerStat[];
};

export default function LineupCard({ teamName, shortName, color, roster }: LineupCardProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
      <div className="flex items-center gap-3 px-4 py-3 border-b border-background-200 bg-background-100">
        <TeamBadge shortName={shortName} color={color} size="sm" />
        <h3 className="font-heading text-base text-foreground-950">{teamName} 阵容</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-xs text-foreground-500">
              <th className="text-left font-normal px-4 py-2">球员</th>
              <th className="text-right font-normal px-3 py-2">得分</th>
              <th className="text-right font-normal px-3 py-2">篮板</th>
              <th className="text-right font-normal px-3 py-2">助攻</th>
            </tr>
          </thead>
          <tbody>
            {roster.map((p, idx) => (
              <tr
                key={`${p.name}-${idx}`}
                className="border-t border-background-100 hover:bg-background-100 transition-colors"
              >
                <td className="px-4 py-2.5">
                  <div className="flex items-center gap-2">
                    <span className="font-label text-xs text-foreground-400 w-5 shrink-0">
                      {p.number}
                    </span>
                    <span className="text-foreground-900">{p.name}</span>
                    <span className="text-[11px] text-foreground-500 px-1.5 py-0.5 rounded bg-background-100">
                      {p.position}
                    </span>
                  </div>
                </td>
                <td className="px-3 py-2.5 text-right font-medium text-foreground-950">{p.points}</td>
                <td className="px-3 py-2.5 text-right text-foreground-700">{p.rebounds}</td>
                <td className="px-3 py-2.5 text-right text-foreground-700">{p.assists}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}